import { Fragment } from 'react';

import useMeetHost from './UseMeetHost';

import MeetHostGrid from './MeetHostGrid';

import DeleteOmeModalInfo from '../../myMeets/meetHost/DeleteOmeModalInfo';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Headings from '@usas/ui-web/components/headings/Headings';

import Constants from '@usas/ui-web/utils/Constants';
import { formatDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const MeetHost = () => {
  const {
    omeMeetHostState,
    gridState,
    modalState,
    meetState,
    omeMeetState,
    omeMeetEntryState,
    onView,
    onEnterOmeHostClicked,
    onEdit,
    onDeleteOmeMeet,
    onDeleteOmeMeetClicked,
    onModalCanceled
  } = useMeetHost();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Host Management</Headings.H3>
        </div>
        <div className="col-xs-12">
          {omeMeetHostState?.objData?.publishDate &&
            <p className={global.HeaderText}><b>Publish Date:</b>
              &nbsp;{omeMeetHostState?.objData?.publishDate && gridState.arrayData?.length > 0 ? formatDateTimeTwelveHourClock(omeMeetHostState?.objData?.publishDate) : ''}
              &nbsp;{omeMeetHostState?.objData?.timeZone && gridState.arrayData?.length > 0 ? omeMeetHostState?.objData?.timeZone : ''}</p>}
          {gridState.arrayData?.length > 0 && omeMeetHostState?.objData?.hostChangesCurrentlyAllowed === false && omeMeetHostState.objData.omeMeetId && <p className={global.HeaderText}><b>The Meet Entry Change Deadline has passed. Editing Host Information is no longer allowed.</b></p>}
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className='col-xs-12'>
          <MeetHostGrid
            gridData={gridState.arrayData}
            isLoading={gridState.isArrayLoading}
            meetState={meetState}
            onView={onView}
            onEnterOmeHostClicked={onEnterOmeHostClicked}
            onEdit={onEdit}
            onDeleteOmeMeetClicked={onDeleteOmeMeetClicked}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={modalState.modalTitle}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCanceled}>
        <div className="row">
          <div className="col-xs-12">
            <DeleteOmeModalInfo modalState={modalState} />
            <p><b>OME Meet Status:</b> {modalState?.status}</p>
          </div>
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onDeleteOmeMeet(e, modalState.omeMeetId)}>Delete</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={omeMeetState.isObjLoading || omeMeetEntryState.isObjLoading || gridState.isArrayLoading || omeMeetHostState.isObjLoading} />
      <PopUpModal
        widthPct={30}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={gridState.isSaving || omeMeetState.isSaving} />
    </Fragment >);
}

export default MeetHost;